import { useState } from "react";
import { quotes } from "@/mocks/guage";

export default function QuotesSection() {
  const [liked, setLiked] = useState<Record<number, boolean>>({});

  const toggle = (index: number) => {
    setLiked((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <section id="quotes" className="relative w-full bg-foreground-950 py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 opacity-20 melon-grid"></div>
      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div>
            <span className="inline-flex items-center gap-2 text-accent-400 text-xs md:text-sm font-medium">
              <span className="w-6 h-px bg-accent-500"></span>
              高能弹幕收录
            </span>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl text-background-50">金句弹幕墙</h2>
            <p className="mt-3 max-w-xl text-sm md:text-base text-background-50/70 leading-relaxed">
              从百万条弹幕里捞出会心一击的那几句。觉得哪句说到心里了，点个赞，它会被更多人看到。
            </p>
          </div>
          <p className="font-heading text-5xl md:text-7xl text-background-50/15 select-none">“ ”</p>
        </div>

        <div className="mt-9 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {quotes.map((quote, index) => {
            const isLiked = Boolean(liked[index]);
            return (
              <figure
                key={quote.text}
                className={`flex flex-col p-5 md:p-6 rounded-lg border transition-colors ${
                  isLiked
                    ? "bg-primary-500/15 border-primary-400/50"
                    : "bg-background-50/5 border-background-50/15 hover:border-accent-400/40"
                }`}
              >
                <i className="ri-double-quotes-l text-2xl text-accent-400"></i>
                <blockquote className="mt-3 text-base md:text-lg text-background-50 leading-relaxed">
                  {quote.text}
                </blockquote>
                <figcaption className="mt-auto pt-5 flex items-center justify-between">
                  <span className="text-xs text-background-50/55 whitespace-nowrap">
                    出自《{quote.source}》
                  </span>
                  <button
                    type="button"
                    onClick={() => toggle(index)}
                    aria-pressed={isLiked}
                    className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
                      isLiked
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50/10 text-background-50/75 hover:bg-background-50/20"
                    }`}
                  >
                    <i className={isLiked ? "ri-heart-fill" : "ri-heart-line"}></i>
                    {quote.likes}
                  </button>
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}